class CollectionTabsElement extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.collection-tabs__tab');
    this.panels = this.querySelectorAll('.collection-tabs__panel');
    this.swipers = new Map();
    this.init();
  }

  init() {
    this.bindEvents();
    this.initSwipers();
    this.activateFirstTab();
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.activateTab(tab);
      });
    });
  }

  activateFirstTab() {
    if (this.tabs.length > 0) {
      this.activateTab(this.tabs[0]);
    }
  }

  activateTab(activeTab) {
    this.tabs.forEach(tab => tab.classList.remove('collection-tabs__tab--active'));
    this.panels.forEach(panel => panel.classList.remove('collection-tabs__panel--active'));

    activeTab.classList.add('collection-tabs__tab--active');

    const targetCollection = activeTab.getAttribute('data-collection');
    const panel = this.querySelector(`[data-collection="${targetCollection}"].collection-tabs__panel`);
    if (panel) {
      panel.classList.add('collection-tabs__panel--active');
      this.updateSwiper(targetCollection);
    }
  }

  initSwipers() {
    this.panels.forEach(panel => {
      const panelId = panel.getAttribute('data-collection');
      const swiperContainer = panel.querySelector('.swiper');

      if (swiperContainer) {
        this.createSwiper(panelId, panel);
      }
    });
  }

  createSwiper(panelId, panel) {
    const swiperContainer = panel.querySelector('.swiper');

    if (!swiperContainer) return;

    const prevBtn = panel.querySelector('.swiper-button-prev');
    const nextBtn = panel.querySelector('.swiper-button-next');
    const scrollbar = panel.querySelector('.swiper-scrollbar');

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        749: {
          slidesPerView: 2.1,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 3.2
        }
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      on: {
        init: function () {
          if (this.navigation.prevEl) this.navigation.prevEl.style.display = 'flex';
          if (this.navigation.nextEl) this.navigation.nextEl.style.display = 'flex';
        }
      }
    });

    this.swipers.set(panelId, swiper);
  }

  updateSwiper(panelId) {
    const swiper = this.swipers.get(panelId);
    if (swiper) {
      swiper.update();
    }
  }
}

customElements.define('collection-tabs', CollectionTabsElement);